/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseCliLoginResponseData } from './genericApiResponseCliLoginResponseData';
import type { GenericApiResponseCliLoginResponseMessage } from './genericApiResponseCliLoginResponseMessage';
import type { GenericApiResponseCliLoginResponsePagination } from './genericApiResponseCliLoginResponsePagination';
import type { GenericApiResponseCliLoginResponseError } from './genericApiResponseCliLoginResponseError';

export interface GenericApiResponseCliLoginResponse {
  data?: GenericApiResponseCliLoginResponseData;
  message?: GenericApiResponseCliLoginResponseMessage;
  pagination?: GenericApiResponseCliLoginResponsePagination;
  error?: GenericApiResponseCliLoginResponseError;
  statusCode?: number;
}
